import Lottie from 'lottie-react';

import LoadingLottie from './loading.json';
import LoadingLottieLight from './loading-light.json';
import LoadingLottieGreen from './loading-green.json';

interface LoadingProps {
  style?: React.CSSProperties;
  size?: number;
  isLight?: boolean;
  isGreen?: boolean;
  isCircularProgress?: boolean;
  isSkeleton?: boolean;
}

export function Loading({
  size = 62,
  isLight = false,
  isGreen = false,
  isSkeleton = false,
}: LoadingProps) {
  if (isLight) {
    return (
      <Lottie
        animationData={LoadingLottieLight}
        style={{ width: size, height: size }}
      />
    );
  }

  if (isGreen) {
    return (
      <Lottie
        animationData={LoadingLottieGreen}
        style={{ width: size, height: size }}
      />
    );
  }

  if (isSkeleton) {
    return (
      <>
        <span className="skeleton" />
        <style>{`
          .skeleton {
            height: 15px;
            width: 100%;
            display: block;
            border-radius: 3px;
            background: linear-gradient(
                to right,
                rgba(255, 255, 255, 0),
                rgba(255, 255, 255, 0.8) 50%,
                rgba(255, 255, 255, 0) 100%
              ),
              #f0f0f0;
            background-repeat: repeat-y;
            background-size: 33%;
            background-position: 0 0;
            animation: shine 1s infinite;
          }

          @keyframes shine {
            to {
              background-position: 100% 0, /* move highlight to right */ 0 0;
            }
          }
        `}</style>
      </>
    );
  }

  return (
    <Lottie
      animationData={LoadingLottie}
      style={{ width: size, height: size }}
    />
  );
}
